
"use client";

import React, { useState } from 'react';
// Removed: import { doc, onSnapshot, type Firestore } from 'firebase/firestore';
// Removed: import { db } from '@/lib/firebase';
import { useSiteStatus } from '@/contexts/SiteStatusContext'; // Import new hook
import { cn } from '@/lib/utils';
import { Info, AlertTriangle, XCircle, X } from 'lucide-react';

// SiteStatus interface removed, will come from context

export function SiteStatusBanner() {
  const { showBanner, bannerMessage, bannerType, loadingStatus } = useSiteStatus(); // Use context
  const [isVisible, setIsVisible] = useState(true); // For user dismissal of the current banner message

  // useEffect for Firestore listener is removed

  // If status is still loading, or if banner shouldn't be shown, or if user dismissed it, return null
  if (loadingStatus || !showBanner || !isVisible) {
    return null;
  }

  // If banner content changes (from context), we should reset isVisible to true
  // This requires a useEffect to watch for changes in bannerMessage/bannerType from context
  React.useEffect(() => {
    if (showBanner) { // Only reset visibility if a banner is supposed to be shown
      setIsVisible(true);
    }
  }, [showBanner, bannerMessage, bannerType]);


  const getBannerStyles = () => {
    switch (bannerType) { // Use bannerType from context
      case 'info':
        return 'bg-blue-600 text-white';
      case 'warning':
        return 'bg-yellow-500 text-black';
      case 'error':
        return 'bg-red-600 text-white';
      default:
        return 'bg-yellow-500 text-black'; // Default to warning
    }
  };

  const getIcon = () => {
    switch (bannerType) { // Use bannerType from context
      case 'info':
        return <Info className="h-5 w-5 mr-3 flex-shrink-0" />;
      case 'warning':
        return <AlertTriangle className="h-5 w-5 mr-3 flex-shrink-0" />;
      case 'error':
        return <XCircle className="h-5 w-5 mr-3 flex-shrink-0" />;
      default:
        return <AlertTriangle className="h-5 w-5 mr-3 flex-shrink-0" />;
    }
  };

  return (
    <div
      className={cn(
        "fixed top-0 left-0 right-0 z-[200] p-3 text-sm shadow-lg flex items-center justify-between",
        getBannerStyles()
      )}
      role="alert"
      data-banner-visible="true" // Used by global CSS to adjust body padding
    >
      <div className="flex items-center">
        {getIcon()}
        <span>{bannerMessage}</span> {/* Use bannerMessage from context */}
      </div>
      <button
        onClick={() => setIsVisible(false)}
        className={cn(
          "ml-4 p-1 rounded-full hover:bg-black/20 focus:outline-none focus:ring-2 focus:ring-white",
          bannerType === 'warning' ? 'hover:bg-black/10 focus:ring-gray-700' : '' // Specific style for warning button hover
        )}
        aria-label="Dismiss banner"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
